import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";

const Shell = ({ children }) => (
  <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
    <div className="card-flat rise w-full max-w-md p-8 text-center">{children}</div>
  </div>
);

export const PaymentSuccess = () => {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) return setState("error");
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["failed", "expired"].includes(data.payment_status)) return setState("error");
      } catch {
        return setState("error");
      }
      if (attempts >= 10) return setState("timeout");
      setTimeout(poll, 2000);
    };
    poll();
  }, [params]);

  return (
    <Shell>
      {state === "checking" && (
        <div data-testid="payment-checking">
          <Loader2 className="mx-auto h-8 w-8 animate-spin text-blue-600" />
          <p className="mt-4 text-sm text-slate-600">{t("pay.checking")}</p>
        </div>
      )}
      {state === "paid" && (
        <div data-testid="payment-success">
          <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-600" />
          <h1 className="mt-4 text-2xl font-extrabold tracking-tight">{t("pay.successTitle")}</h1>
          <p className="mt-2 text-sm text-slate-600">{t("pay.successText")}</p>
        </div>
      )}
      {(state === "error" || state === "timeout") && (
        <div data-testid="payment-error">
          <XCircle className="mx-auto h-10 w-10 text-amber-600" />
          <h1 className="mt-4 text-xl font-extrabold tracking-tight">{t("pay.pendingTitle")}</h1>
          <p className="mt-2 text-sm text-slate-600">{t("pay.pendingText")}</p>
        </div>
      )}
      <Link to="/abbonamento">
        <Button data-testid="back-to-app" className="mt-6 bg-slate-900 text-white hover:bg-slate-800">
          {t("pay.back")}
        </Button>
      </Link>
    </Shell>
  );
};

export const PaymentCancel = () => {
  const { t } = useI18n();
  return (
    <Shell>
      <div data-testid="payment-cancel">
        <XCircle className="mx-auto h-10 w-10 text-slate-400" />
        <h1 className="mt-4 text-xl font-extrabold tracking-tight">{t("pay.cancelTitle")}</h1>
        <p className="mt-2 text-sm text-slate-600">{t("pay.cancelText")}</p>
      </div>
      <Link to="/abbonamento">
        <Button data-testid="back-to-app" className="mt-6 bg-slate-900 text-white hover:bg-slate-800">
          {t("pay.back")}
        </Button>
      </Link>
    </Shell>
  );
};
